// src/config.js

export const BASE_URL = "http://localhost/trv/12333";

export const token = localStorage.getItem("authToken") || null;
 